import React from "react";

const InfoIcon = props => (
    <svg {...props} fill="currentcolor" version="1.1" width="32" height="32" viewBox="0 0 32 32">    
        <path d="M25.92 7.36c-4.8-4.8-12.48-4.8-17.28 0s-4.8 12.48 0 17.28c4.8 4.8 12.48 4.8 17.28 0s4.8-12.48 0-17.28zM16.96 5.92c1.28 0 2.4 1.12 2.4 2.4s-1.12 2.4-2.4 2.4c-1.28 0-2.4-1.12-2.4-2.4 0.16-1.44 1.12-2.4 2.4-2.4zM20.8 23.2c0 0.48-0.16 0.8-0.8 0.8h-6.080c-0.48 0-0.8-0.32-0.8-0.8v-1.6c0-0.48 0.32-0.8 0.8-0.8h1.12v-6.4h-1.12c-0.48 0-0.64-0.32-0.64-0.8v-1.6c0-0.48 0.16-0.8 0.8-0.8h4.16c0.48 0 0.8 0.16 0.8 0.8v8.8h1.12c0.48 0 0.8 0.16 0.8 0.8v1.6z"></path>
    </svg>
);

export default InfoIcon;